import { createConsumer } from "@rails/actioncable";

const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:3000").replace(/\/$/, "");
const WS_URL  = API_URL.replace(/^http/, "ws");

export function createCable() {
  const token = localStorage.getItem("jwt");
  return createConsumer(`${WS_URL}/cable?token=${token}`);
}
